import VendorsTable from "./table";

const Vendors = () => {
  return <VendorsTable />;
};

export default Vendors;
